export class Actual {
      public kaizenActualId!: number;
      public kaizenAccountId!: number;
      public actualValue!: number;
      public calendarMonthId!: number;
      public modifiedBy! : string
      public modifiedOn! : string
      public createdBy!: string
      public createdOn!: string
      
  }

  export class PagedResponseRank{
      public pageNumber!: number;
      public pageSize!:number;
      public succeeded!:boolean
      public message!:string;
      public errors!:string;
      public data!:Actual[];
  }

  export class ChangedActuals{
    public actuals!:Actual[]
  }